import { ConfirmModal } from '@/components/modal/confirm-modal/ConfirmModal.component';
import {
  DatePicker,
  DatePickerInput,
  Select,
  SelectItem,
  TextInput,
} from 'carbon-components-react';
import { useCustomMutation } from '@/utils/useCustomMutation';
import { postMethod } from '@/api/common';
import React from 'react';

export default function SetHolidays({ isOpen, closeModal, onSuccess }) {
  const [name, setName] = React.useState('');
  const [type, setType] = React.useState('day');
  const [startDate, setStartDate] = React.useState('');
  const [endDate, setEndDate] = React.useState('');

  const { trigger, isMutating, error, reset } = useCustomMutation(
    'school-calendar/holidays/create',
    (url, { arg }) => postMethod(url, arg),
  );

  const resetForm = () => {
    setName('');
    setType('day');
    setStartDate('');
    setEndDate('');
    reset();
  };

  const handleClose = () => {
    resetForm();
    closeModal();
  };

  const handleSubmit = () => {
    const payload = { name, startDate };
    if (type === 'range' && endDate) {
      payload.endDate = endDate;
    }
    trigger(payload, {
      onSuccess: () => {
        resetForm();
        closeModal();
        onSuccess?.();
      },
    });
  };

  return (
    <ConfirmModal
      title="Set Holiday / Break"
      isOpen={isOpen}
      closeModal={handleClose}
      actionText="Save"
      secondaryActionText="Cancel"
      secondaryBtnClasses="secondary"
      isLoading={isMutating}
      onClick={handleSubmit}
      description={
        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
          <TextInput
            id="holiday-name"
            labelText="Name"
            placeholder="e.g., Christmas Break"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <Select
            id="holiday-type"
            labelText="Type"
            value={type}
            onChange={(e) => setType(e.target.value)}
          >
            <SelectItem value="day" text="Single Day" />
            <SelectItem value="range" text="Date Range" />
          </Select>
          <DatePicker
            dateFormat="Y-m-d"
            datePickerType="single"
            id="holiday-start-date"
            onChange={(value) => {
              if (value.length > 0) {
                setStartDate(
                  [
                    value[0].getFullYear(),
                    ('0' + (value[0].getMonth() + 1)).slice(-2),
                    ('0' + value[0].getDate()).slice(-2),
                  ].join('-'),
                );
              } else setStartDate('');
            }}
          >
            <DatePickerInput
              id="holiday-start"
              name="startDate"
              labelText="Start Date"
              value={startDate}
              placeholder="YYYY-MM-DD"
              type="text"
              onChange={(e) => setStartDate(e.target.value)}
            />
          </DatePicker>
          {type === 'range' && (
            <DatePicker
              dateFormat="Y-m-d"
              datePickerType="single"
              id="holiday-end-date"
              onChange={(value) => {
                if (value.length > 0) {
                  setEndDate(
                    [
                      value[0].getFullYear(),
                      ('0' + (value[0].getMonth() + 1)).slice(-2),
                      ('0' + value[0].getDate()).slice(-2),
                    ].join('-'),
                  );
                } else setEndDate('');
              }}
            >
              <DatePickerInput
                id="holiday-end"
                name="endDate"
                labelText="End Date"
                value={endDate}
                placeholder="YYYY-MM-DD"
                type="text"
                onChange={(e) => setEndDate(e.target.value)}
              />
            </DatePicker>
          )}
        </div>
      }
      errorMessage={error ? error.message : null}
    />
  );
}
